export default __webpack_public_path__ + "static/main_mobile_reversed-poster-c67ff21c8e27a677bf1a5ff0c2c49f07.avif";